import { toggleMenu } from "./header";
import { scrollToHash, getSamePageAnchor } from "./smooth-scrolling";
import '../css/main.css';


document.addEventListener("DOMContentLoaded", () => {
  /**
   * Toggle del header
   */
  toggleMenu()

  /**
   * Example carousel import
   */
  const carousel = document.querySelectorAll(".carousel");
  if (carousel.length > 0) {
    import("./carousel").then((module) => {
      carousel.forEach((slider) => {
        module.carousel(slider);
      });
    });
  }

  /**
   * Smooth scrolling support
   */
  // If a link's href is within the current page, scroll to it instead
  document.querySelectorAll('a[href]').forEach(a => {
    a.addEventListener('click', e => {
      scrollToHash(getSamePageAnchor(a), e);
    });
  });
  // Scroll to the element in the URL's hash on load
  scrollToHash(window.location.hash);

  /**
   * ACF7 event listener
   */
  document.addEventListener('wpcf7mailsent', (event) => {
    gtag('event', 'Formulario', {
      'event_category': event.detail.contactFormId,
      'event_label': event.detail.unitTag
    });
  }, false);

  /**
   * Single product scripts
   */
  const singleProduct = document.querySelector('.wp-singular.single-product');
  if (singleProduct) {
    import("./single-product").then((module) => {
      module.handleRelatedProductsCarousel();
    });
  }

  /**
   * Obituaries modal (popup)
   */
  const hasModal = document.getElementById('obit-modal');
  const hasOpener = document.querySelector('.js-obit-open');
  if (hasModal && hasOpener) {
    import("./popup").then((m) => {
      m.initObitsModal();
    });
  }

  // const footerLogoLink = document.querySelector('#footer .custom-logo-link');
  // if (footerLogoLink) {
  //   footerLogoLink.addEventListener('click', (e) => {
  //     e.preventDefault();
  //     // Scroll to top
  //     window.scrollTo({ top: 0, behavior: 'smooth' });
  //   });
  // }
});



